// DCL-605: shows one stored campaign email exactly as it was sent. The HTML is
// rendered in an <iframe sandbox srcdoc> (console_sent_email_modal.html) that
// allows popups and nothing else: no allow-scripts, no allow-same-origin, so
// the email's markup cannot run script in the console or restyle it. Trusting
// it for $sce is what lets Angular bind it to srcdoc; the sandbox, not $sce, is
// what keeps it contained.
//
// A <base target="_blank"> is put in front of the email so its links open in a
// new tab (allow-popups-to-escape-sandbox lets that tab load normally) rather
// than doing nothing or loading the site inside the modal's frame.
angular.module('console')
    .controller('SentEmailModalController', ['$scope', '$sce', '$uibModalInstance', 'Practice', 'Logger', 'practiceId', 'sentEmail',
        function ($scope, $sce, $uibModalInstance, Practice, Logger, practiceId, sentEmail) {
            var BASE_NEW_TAB = '<base target="_blank">';

            function withLinksInNewTab(html) {
                html = html || '';
                // The first <base> with a target wins, so it goes first inside <head>...
                if (/<head\b[^>]*>/i.test(html)) {
                    return html.replace(/<head\b[^>]*>/i, function (head) { return head + BASE_NEW_TAB; });
                }
                // ...or, with no <head>, at the very start: after any doctype,
                // which must stay first to keep the frame out of quirks mode.
                return html.replace(/^(\s*<!doctype[^>]*>)?/i, function (doctype) {
                    return (doctype || '') + BASE_NEW_TAB;
                });
            }

            $scope.sentEmail = sentEmail;
            $scope.loading = true;
            $scope.failed = false;
            $scope.html = null;

            Practice.getSentEmail({practiceId: practiceId, emailId: sentEmail.id}, function (email) {
                $scope.loading = false;
                $scope.html = $sce.trustAsHtml(withLinksInNewTab(email.html_body));
            }, function (error) {
                $scope.loading = false;
                $scope.failed = true;
                Logger.log('Failed to load sent email', error);
            });

            $scope.close = function () {
                $uibModalInstance.dismiss('close');
            };
        }]);
